import React from 'react';
import Icon from '../../../components/AppIcon';

const MetricsCard = ({ 
  title, 
  value, 
  subtitle, 
  icon, 
  trend = null, 
  color = 'primary',
  onClick = null,
  className = '' 
}) => {
  const getColorClasses = () => {
    switch (color) {
      case 'success':
        return 'bg-success text-success-foreground';
      case 'warning':
        return 'bg-warning text-warning-foreground';
      case 'error':
        return 'bg-error text-error-foreground';
      default:
        return 'bg-primary text-primary-foreground';
    }
  };

  const getTrendIcon = () => {
    if (!trend) return null;
    return trend > 0 ? 'TrendingUp' : trend < 0 ? 'TrendingDown' : 'Minus';
  };

  const getTrendColor = () => {
    if (!trend) return '';
    return trend > 0 ? 'text-success' : trend < 0 ? 'text-error' : 'text-muted-foreground';
  };

  return (
    <div 
      className={`
        bg-card border border-border rounded-lg p-6 hover:shadow-md transition-all duration-200
        ${onClick ? 'cursor-pointer hover:bg-muted' : ''}
        ${className}
      `}
      onClick={onClick}
    >
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-muted-foreground mb-1">{title}</p>
          <div className="flex items-baseline space-x-2">
            <p className="text-2xl font-bold text-foreground">{value}</p>
            {trend !== null && (
              <div className={`flex items-center space-x-1 ${getTrendColor()}`}>
                <Icon name={getTrendIcon()} size={14} />
                <span className="text-xs font-medium">
                  {Math.abs(trend)}%
                </span>
              </div>
            )}
          </div>
          {subtitle && (
            <p className="text-xs text-muted-foreground mt-1">{subtitle}</p>
          )}
        </div>
        
        <div className={`p-3 rounded-lg ${getColorClasses()}`}>
          <Icon name={icon} size={20} />
        </div>
      </div>
    </div>
  );
};

export default MetricsCard;